import { useEffect, useState } from 'react';
import { navigate } from '@/hooks/useRoute';
import './FirstPurchasePopup.css';

const SESSION_KEY = 'mielley_first_purchase_popup_seen_v3';

export function FirstPurchasePopup() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    try {
      if (sessionStorage.getItem(SESSION_KEY)) return;
    } catch {}

    const timer = window.setTimeout(() => setOpen(true), 900);
    return () => window.clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (!open) return;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') closePopup();
    };

    window.addEventListener('keydown', onKeyDown);
    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener('keydown', onKeyDown);
    };
  }, [open]);

  const remember = () => {
    try {
      sessionStorage.setItem(SESSION_KEY, '1');
    } catch {}
  };

  const closePopup = () => {
    remember();
    setOpen(false);
  };

  const shop = () => {
    remember();
    setOpen(false);
    navigate('/catalog');
  };

  if (!open) return null;

  return (
    <div
      className="mfp42-overlay"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) closePopup();
      }}
    >
      <section
        className="mfp42-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="mfp42-title"
        dir="rtl"
      >
        <button
          className="mfp42-close"
          type="button"
          aria-label="סגירה"
          onClick={closePopup}
        >
          ×
        </button>

        <div className="mfp42-image" aria-hidden="true">
          <img src="/assets/mielley-popup-model-v3.png" alt="" />
        </div>

        <div className="mfp42-content">
          <div className="mfp42-brand" aria-label="MIELLEY Jewelry">
            <strong>MIELLEY</strong>
            <span><i />JEWELRY<i /></span>
          </div>

          <h2 id="mfp42-title">
            <span className="mfp42-offer-line"><b>10%</b> הנחה</span>
            <span>לקנייה הראשונה</span>
          </h2>

          <div className="mfp42-divider" aria-hidden="true">
            <span />
            <b>◆</b>
            <span />
          </div>

          <div className="mfp42-message">
            <p>תכשיטי מוסונייט וכסף 925 בעיצוב יוקרתי.</p>
            <strong>יוקרה בלי פשרות. במחיר הכי הוגן.</strong>
          </div>

          <div className="mfp42-benefits" aria-label="יתרונות MIELLEY">
            <div><i>◇</i><span>מוסונייט איכותי</span></div>
            <div><i className="mfp42-925">925</i><span>כסף סטרלינג 925</span></div>
            <div><i>♡</i><span>שירות אישי</span></div>
          </div>

          <button type="button" className="mfp42-cta" onClick={shop}>
            <span>לגלות את הקולקציה</span>
            <b aria-hidden="true">←</b>
          </button>

          <p className="mfp42-fineprint">
            הטבת 10% ללקוחות חדשים בלבד ובהתאם לתקנון.
          </p>
        </div>
      </section>
    </div>
  );
}
